import React, { Component } from "react";
import ContentWrapper from "../../../Layout/ContentWrapper";
import axios from "../../../../services/axios";
import Datatable from "../../../Common/Datatable";
import {
  Container, Card, CardHeader, CardBody, CardTitle, Row, Col, Button, Nav, TabContent, TabPane,
  NavItem,
  NavLink
} from "reactstrap";
import $ from "jquery";
import Moment from "moment"
import classnames from 'classnames';
import NumberFormat from 'react-number-format'

class PrePaidInvoiceList extends Component {
  state = {
    activeTab: '1',
    bill: {},
    invoiceId: 0,
    paidStatus: "0",
    customer: {}
  };

  componentDidMount() {


    const { state } = this.props.history.location;
    // console.log(state.id)
    if (state == undefined) {
      return this.props.history.push('/prepaid-invoices/')
    }
    this.setState({ invoiceId: state.id })
    this.setState({ paidStatus: state.status })



    axios.get("/bills/" + state.id)
      .then(res => {
        const response = res.data;
        this.setState({ bill: response })

      })

    axios.get("/customers/me")
      .then(res => {
        const response = res.data;
        this.setState({ customer: response })

      })



  }

  toggleTab = tab => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }



  formatDate = (date) => {
    return Moment(date).format('DD-MM-YYYY')
  }


  ViewAllInvoices = () => {
    return this.props.history.push("/prepaid-invoices");
  };

  AddActionButtonStyle = {
    color: 'white',
    background: "#003366"
  }


  render() {
    return (

      <ContentWrapper>
        <div className="content-heading">


          <div className="mr-auto flex-row">
            Invoice Details
            <small>Details of an invoice</small>
          </div>
          <div className="flex-row">
            <Button onClick={this.ViewAllInvoices} style={this.AddActionButtonStyle} className="btn-pill-right mr-2">Back to Invoices</Button>
          </div>
        </div>
        <Row>
          <Col xl="12">
            <div className="card mx-md-3">
              <div className="card-header px-md-4 py-lg-4 py-md-3 d-flex">
                <h3 className="mt-2">Invoice <span>#{this.state.bill.billNumber}</span></h3>
                {/* <Button color="success" className="btn-pill ml-auto px-md-5">
                                    <span className="fa fa-print"></span> &nbsp; Print
                                </Button> */}
              </div>
              <hr className="my-0" />
              <div className="card-body my-2 py-1 px-lg-5 px-3">
                <div className="row pt-3 px-lg-3">
                  <div className="col-lg-5 px-lg-3">
                    <h4>From:</h4>
                    <p style={this.InvoiceHeader}>Web Corporation Tanzania,</p>
                    <p style={this.InvoiceHeader}>Al Falah (KFC) Building, 4th Floor,</p>
                    <p style={this.InvoiceHeader}>Livingstone/Msimbazi Street,</p>
                    <p style={this.InvoiceHeader}>P.O.Box 70307,</p>
                    <p style={this.InvoiceHeader}>Dar es Salaam, Tanzania.</p>
                    <p style={this.InvoiceHeader}>Helpdesk: +255 716 888 333 / +255 685 888 333</p>
                  </div>
                  <div className="col-lg-4 px-lg-3">
                    <h4>To:</h4>
                    <p style={this.InvoiceHeader}>{this.state.bill.customerName}</p>
                  </div>
                  <div className="col-lg-3 px-lg-3">
                    <h4>Invoice:</h4>
                    <p style={this.InvoiceHeader}>Invoice Number: &nbsp; <span>{this.state.bill.billReference}</span></p>

                    <p style={this.InvoiceHeader}>Invoice Date: &nbsp; <span>{this.formatDate(this.state.bill.createdAt)}</span></p>
                    <p style={this.InvoiceHeader}>Invoice Status: &nbsp;
                      {this.state.bill.status == "Pending" &&
                        <span className="alert alert-danger px-3 py-1">Unpaid</span>
                      }
                      {this.state.bill.status == "Paid" &&
                        <span className="alert alert-success px-3 py-1">Paid</span>
                      }

                    </p>
                    <p style={this.InvoiceHeader}><strong>Invoice Total: &nbsp; <span>{this.state.bill.paidAmount}</span> Tsh.</strong></p>
                  </div>
                </div>
                <table class="table table-striped table-bordered my-4">
                  <thead>
                    <tr>
                      <th scope="col" className="text-dark">Item Description</th>
                      <th scope="col" className="text-dark">Unit Price (Tsh)</th>
                      <th scope="col" className="text-dark">Quantity</th>
                      <th scope="col" className="text-dark">Amount (Tsh.)</th>
                      <th scope="col" className="text-dark">VAT (18%)</th>
                      <th scope="col" className="text-dark">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>SMS Subscription Payment.</td>
                      <td>{this.state.bill.pricePerSms}</td>
                      <td>{this.state.bill.smsQuantity}</td>
                      <td>{this.state.bill.billAmount}</td>
                      <td>{this.state.bill.paidAmount - this.state.bill.billAmount}</td>
                      <td>{this.state.bill.paidAmount}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr className="bg-light">
                      <th>Sub Total (Tsh.)</th>
                      <th>{this.state.bill.paidAmount}</th>
                    </tr>
                    <tr className="bg-dark text-white">
                      <th>Total Amount (Tsh.)</th>
                      <th>{this.state.bill.paidAmount}</th>
                    </tr>
                  </tfoot>
                </table>


                <div role="tabpanel card card-body">
                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: this.state.activeTab === '1' })}
                        onClick={() => { this.toggleTab('1'); }}>
                        <span className="icon-briefcase mr-2"></span>
                        M-PESA
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: this.state.activeTab === '2' })}
                        onClick={() => { this.toggleTab('2'); }}>
                        <span className="icon-briefcase mr-2"></span>
                        TIGO PESA
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: this.state.activeTab === '3' })}
                        onClick={() => { this.toggleTab('3'); }}>
                        <span className="icon-briefcase mr-2"></span>
                        AIRTEL MONEY
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: this.state.activeTab === '4' })}
                        onClick={() => { this.toggleTab('4'); }}>
                        <span className="icon-briefcase mr-2"></span>
                        HALO PESA
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: this.state.activeTab === '5' })}
                        onClick={() => { this.toggleTab('5'); }}>
                        <span className="icon-briefcase mr-2"></span>
                        T PESA
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: this.state.activeTab === '6' })}
                        onClick={() => { this.toggleTab('6'); }}>
                        <span className="icon-briefcase mr-2"></span>
                        EZY PESA
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: this.state.activeTab === '7' })}
                        onClick={() => { this.toggleTab('7'); }}>
                        <span className="icon-briefcase mr-2"></span>
                        SELCOM PAY / MASTERPASS QR
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId="1">

                      <Col xl="12">
                        <h4 className="mt-3 mt-lg-4">How to pay via M PESA in your phone.</h4>
                        <ul style={this.InvoiceHeader}>
                          <li className="mb-1">Dial  <strong>*150*00#</strong></li>
                          <li className="mb-1">Choose 4 - Lipa by M-Pesa </li>
                          <li className="mb-1">Choose 4 - Enter bussiness Number</li>
                          <li className="mb-1">Enter <strong>'123123' (Selcom Pay Bussiness Number)</strong></li>
                          <li className="mb-1">Enter Reference Number <strong>'{this.state.bill.billNumber}'</strong></li>
                          <li className="mb-2">Enter Amount <strong>'{this.state.bill.billAmount}'</strong></li>
                          <li className="mb-2">Enter PIN </li>
                          <li className="mb-2">You will receive confirmation SMS </li>
                        </ul>
                      </Col>
                    </TabPane>

                    <TabPane tabId="2">

                      <Col xl="12">
                        <h4 className="mt-3 mt-lg-4">How to pay via TIGO PESA in your phone.</h4>
                        <ul style={this.InvoiceHeader}>
                          <li className="mb-1">Dial  <strong>*150*01#</strong></li>
                          <li className="mb-1">Choose 5 - Pay Merchant </li>
                          <li className="mb-1">Choose 2 - Pay Masterpass QR Merchant</li>
                          <li className="mb-1">Enter 8 digits Merchant Number <strong>'{this.state.bill.billNumber}'</strong></li>
                          <li className="mb-2">Enter Amount <strong>'{this.state.bill.billAmount}'</strong></li>
                          <li className="mb-2">Enter PIN </li>
                          <li className="mb-2">You will receive confirmation SMS </li>
                        </ul>
                      </Col>
                    </TabPane>

                    <TabPane tabId="3">

                      <Col xl="12">
                        <h4 className="mt-3 mt-lg-4">How to pay via AIRTEL MONEY in your phone.</h4>
                        <ul style={this.InvoiceHeader}>
                          <li className="mb-1">Dial  <strong>*150*60#</strong></li>
                          <li className="mb-1">Choose 5 - Make Payments </li>
                          <li className="mb-1">Choose 1 - Merchant Payments</li>
                          <li className="mb-1">Choose 1 - Pay with SelcomPay/Masterpass</li>
                          <li className="mb-2">Enter Amount <strong>'{this.state.bill.billAmount}'</strong></li>
                          <li className="mb-1">Enter Reference Number <strong>'{this.state.bill.billNumber}'</strong></li>
                          <li className="mb-2">Enter PIN </li>
                          <li className="mb-2">You will receive confirmation SMS </li>
                        </ul>
                      </Col>
                    </TabPane>

                    <TabPane tabId="4">
                      <Col xl="12">
                        <h4 className="mt-3 mt-lg-4">How to pay via HALO PESA in your phone.</h4>
                        <ul style={this.InvoiceHeader}>
                          <li className="mb-1">Dial  <strong>*150*88#</strong></li>
                          <li className="mb-1">Choose 5 - Pay Merchant </li>
                          <li className="mb-1">Choose 3 - SelcomPay/Masterpass</li>
                          <li className="mb-1">Enter Pay Number <strong>'{this.state.bill.billNumber}'</strong></li>
                          <li className="mb-2">Enter Amount <strong>'{this.state.bill.billAmount}'</strong></li>
                          <li className="mb-2">Enter PIN </li>
                          <li className="mb-2">You will receive confirmation SMS </li>
                        </ul>
                      </Col>
                    </TabPane>

                    <TabPane tabId="5">
                      <Col xl="12">
                        <h4 className="mt-3 mt-lg-4">How to pay via T PESA in your phone.</h4>
                        <ul style={this.InvoiceHeader}>
                          <li className="mb-1">Dial  <strong>*150*71#</strong></li>
                          <li className="mb-1">Choose 6 - Pay Merchant </li>
                          <li className="mb-1">Choose 2 - SelcomPay/Masterpass</li>
                          <li className="mb-1">Enter Pay Number <strong>'{this.state.bill.billNumber}'</strong></li>
                          <li className="mb-2">Enter Amount <strong>'{this.state.bill.billAmount}'</strong></li>
                          <li className="mb-2">Enter PIN </li>
                          <li className="mb-2">You will receive confirmation SMS </li>
                        </ul>
                      </Col>
                    </TabPane>

                    <TabPane tabId="6">
                      <Col xl="12">
                        <h4 className="mt-3 mt-lg-4">How to pay via EZY PESA in your phone.</h4>
                        <ul style={this.InvoiceHeader}>
                          <li className="mb-1">Dial  <strong>*150*02#</strong></li>
                          <li className="mb-1">Choose 5 - Payments </li>
                          <li className="mb-1">Choose 1 - Lipa Hapa</li>
                          <li className="mb-1">Choose 2 - SelcomPay/Masterpass QR</li>
                          <li className="mb-1">Enter Merchant Number <strong>'{this.state.bill.billNumber}'</strong></li>
                          <li className="mb-2">Enter Amount <strong>'{this.state.bill.billAmount}'</strong></li>
                          <li className="mb-2">Enter PIN </li>
                          <li className="mb-2">You will receive confirmation SMS </li>
                        </ul>
                      </Col>
                    </TabPane>

                    <TabPane tabId="7">
                      <Col xl="12">
                        <h4 className="mt-3 mt-lg-4">How to pay via SELCOM MASTERPASS in your phone.</h4>
                        <ul style={this.InvoiceHeader}>
                          <li className="mb-1">Dial  <strong>*150*50#</strong></li>
                          <li className="mb-2">Enter PIN </li>
                          <li className="mb-1">Choose 2 - SelcomPay/Masterpass QR</li>
                          <li className="mb-1">Enter Pay Number <strong>'{this.state.bill.billNumber}'</strong></li>
                          <li className="mb-2">Enter Amount <strong>'{this.state.bill.billAmount}'</strong></li>
                          <li className="mb-1">Enter '1' to confirm payment </li>  
                          <li className="mb-2">You will receive confirmation SMS </li>
                        </ul>
                      </Col>
                    </TabPane>
                  </TabContent>

                </div>
              </div>
            </div>
          </Col>
        </Row>
      </ContentWrapper>

    );
  }
}

export default PrePaidInvoiceList;
